<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div
      id="editorigin"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" id="modal">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="px-2 mb-0">
                {{ $t("edit_origin") }}
              </h5>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="editorgin">
              <div
                class="flex-container"
                style="display: flex; justify-content: space-between; gap: 1rem;"
              >
                <div style="width: 100%;">
                  <div class="form-group">
                    <label for="name"> {{ $t("name") }}</label>
                    <input
                      type="text"
                      name="name"
                      v-model="name"
                      class="form-control"
                      required
                      id="name"
                      :placeholder="$t('enter-name')"
                      style="text-transform: capitalize;"
                      @keypress="isLetter($event)"
                    />
                  </div>

                  <div class="form-group">
                    <label for="region"> {{ $t("region") }}</label>
                    <input
                      v-model="region"
                      type="text"
                      name="region"
                      class="form-control"
                      required
                      id="region"
                      :placeholder="$t('enter-region')"
                    />
                  </div>
                </div>

                <div style="width: 100%;">
                  <div class="form-group">
                    <label for="address"> {{ $t("address") }}</label>
                    <input
                      type="text"
                      name="address"
                      class="form-control"
                      required
                      id="autocomplete"
                      :placeholder="$t('enter-address')"
                      @input="onInputChange"
                      v-model="address"
                    />
                  </div>

                  <div class="form-group">
                    <label for="country"> {{ $t("country") }} </label>
                    <CountrySelect
                      class="form-control"
                      required
                      id="country"
                      v-model="country"
                      :country="country"
                      :countryLabel="'Select a Country'"
                      :defaultOption="'Select a country'"
                      :countryName="true"
                    />
                  </div>
                </div>
              </div>

              <div type="submit" class="btn-add">
                <button
                  :disabled="!isValidLocation"
                  :class="{
                    'invalid-button': !isValidLocation,
                    'valid-button': isValidLocation,
                  }"
                >
                  {{ $t("save") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import vClickOutside from "v-click-outside";

import loadGoogleMapsApi from "load-google-maps-api";

import { CountrySelect } from "vue-country-region-select";

export default {
  name: "EditOrigin",
  components: {
    Loading,
    CountrySelect,
  },

  props: {
    show: Boolean,
    origin: Array,
  },

  data() {
    return {
      isLoading: false,
      fullPage: true,

      name: "",
      region: "",
      lat: null,
      lng: null,
      mssg: "",
      Errormssg: "",
      country: "",

      address: "",
      previousAddress: "",
      isClearing: false,
      isValidLocation: true,
    };
  },

  computed: {
    ...mapGetters(["origins"]),
  },
  mounted() {
    this.initialiseForm();

    this.$nextTick(() => {
      this.initializeAutocomplete();
    });
  },
  watch: {
    origin: {
      handler: function() {
        this.initialiseForm();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["editOrigin", "getOrigin"]),

    validateLocation() {
      this.isValidLocation =
        this.lat !== null &&
        this.lng !== null &&
        this.lat >= -90 &&
        this.lat <= 90 &&
        this.lng >= -180 &&
        this.lng <= 180;
    },

    onInputChange() {
      this.isClearing = this.address.length < this.previousAddress.length;

      this.previousAddress = this.address;

      if (this.isClearing || !this.address) {
        this.lat = null;
        this.lng = null;
      }

      this.validateLocation();
    },

    onCancel() {
      this.$emit("closeEditOriginModal");
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
    initializeAutocomplete() {
      const { google } = window;
      this.geocoder = new google.maps.Geocoder();
      const input = document.getElementById("autocomplete");
      const autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (place && place.formatted_address) {
          this.address = place.formatted_address;

          const latLng = place.geometry?.location;

          if (latLng) {
            this.lat = latLng.lat();
            this.lng = latLng.lng();
            console.log("Latitude:", this.lat);
            console.log("Longitude:", this.lng);
          }
        } else {
          const inputAddress = document.getElementById("autocomplete").value;
          console.log(
            "Address not found in autocomplete, geocoding:",
            inputAddress
          );

          this.geocoder.geocode(
            { address: inputAddress },
            (results, status) => {
              if (
                status === google.maps.GeocoderStatus.OK &&
                results.length > 0
              ) {
                const result = results[0];

                const latLng = result.geometry.location;
                this.lat = latLng.lat();
                this.lng = latLng.lng();

                console.log("Geocoded Latitude:", this.lat);
                console.log("Geocoded Longitude:", this.lng);
              } else {
                console.error("Geocoding failed:", status);
              }
            }
          );
        }
        this.validateLocation();
      });
    },

    initialiseForm() {
      if (this.origin && this.origin.length > 0) {
        // let autocompleteInput = document.getElementById("autocomplete");

        setTimeout(() => {
          this.name = this.origin[0].name;

         this.address = this.origin[0].address.name;

          this.region = this.origin[0].region;
          this.country = this.origin[0].country;
          this.lat = this.origin[0].address.lat;
          this.lng = this.origin[0].address.lng;
        }, 200);
      }
    },

    editorgin() {
      this.isLoading = true;

      const newOrigin = {
        name: this.name,
        address: {
          name: document.getElementById("autocomplete").value,
          lng: this.lng,
          lat: this.lat,
        },
        region: this.region,
        country: this.country,
      };
      this.editOrigin({ newOrigin, id: this.origin[0].id })
        .then((res) => {
          this.getOrigin().then(() => {
            this.onCancel();
          });
          this.$emit("showSuccessPopup", {
            msg: this.$t("edited_origin_mssg"),
            heading: this.$t("edited_origin_heading"),
          });
          this.isLoading = false;
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}

label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}

.valid-button {
  background-color: rgba(33, 62, 122, 1);
  cursor: pointer;
}

.invalid-button {
  background-color: rgba(33, 62, 122, 0.8);
}

@media (max-width: 576px) {
  .modal-dialog {
    max-width: 360px !important;
    margin: 0 auto;
  }
}
</style>
